export enum PaymentMethods {
  CREDIT_CARD = 1,
  BANKSLIP = 2,
  ONLINEDEBT = 3,
  DEBIT_CARD = 4,
  PIX = 5,
  FREE = 6,
  ZERO_VALUE = 7,
  CASH = 8,
}

export const PaymentMethodLabels = {
  [PaymentMethods.CREDIT_CARD]: 'Cartão de Crédito',
  [PaymentMethods.BANKSLIP]: 'Boleto',
  [PaymentMethods.ONLINEDEBT]: 'Débito Online',
  [PaymentMethods.DEBIT_CARD]: 'Cartão de Débito',
  [PaymentMethods.FREE]: 'Cartão de Débito',
  [PaymentMethods.PIX]: 'Pix',
  [PaymentMethods.ZERO_VALUE]: 'Valor Isento',
  [PaymentMethods.CASH]: 'Dinheiro',
}
